<!-- ============================================================================= -->
<!-- Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

document.addEventListener('click', function (e) {
    var btn = e.target.closest('#halo-cart-sidebar .button-continue');
    if (btn) {
        e.preventDefault();
        var closeBtn = document.querySelector('#halo-cart-sidebar .halo-sidebar-close');
        if (closeBtn) closeBtn.click();
    }
});

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
